import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from 'common/Container';

const Hero = () => {
  const theme = useTheme();

  return (
    <Box
      minHeight={{ xs: 'auto', md: 'calc(100vh - 64px)' }}
      height="auto"
      position="relative"
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{
        backgroundImage:
          'linear-gradient(135deg, rgba(0, 82, 73, 0.92) 0%, rgba(0, 128, 105, 0.92) 100%)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        '&:after': {
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          content: '" "',
          zIndex: 1,
          backgroundColor: theme.palette.primary.dark,
          opacity: 0.72,
        },
      }}
    >
      <Box position="relative" zIndex={2} width="100%">
        <Container>
          <Box textAlign="center" color="common.white">
            <Typography
              sx={{ textTransform: 'uppercase', fontWeight: 600, letterSpacing: 1 }}
              variant="overline"
              display="block"
              gutterBottom
            >
              Propuesta de Sistema Web
            </Typography>
            <Typography variant="h2" fontWeight={900} gutterBottom align="center">
              Control de Gastos Inteligente
              <br />
              INDESAGRO
            </Typography>
            <Typography
              variant="h6"
              component="p"
              align="center"
              sx={{ fontWeight: 400, opacity: 0.95 }}
            >
              Registro, visualización y análisis automatizado de egresos
            </Typography>
            <Typography
              variant="body1"
              align="center"
              sx={{ mt: 2, opacity: 0.9, maxWidth: 760, mx: 'auto' }}
            >
              Aplicación web que reduce el trabajo manual, mejora la toma de
              decisiones y se adapta a entornos con variación del tipo de cambio.
            </Typography>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Hero;
